module.exports = __webpack_public_path__ + "img/rxk_img1.34de1d86.png";